import { useAuthRole } from '@app/utils';
import { ILeave } from '../types';

interface Props {
  row: ILeave;
  setShowSendMail: (value: boolean) => void;
}
const SendMail = ({ row, setShowSendMail }: Props) => {
  setShowSendMail(false);
  const { isManager } = useAuthRole();
  const recipient = isManager ? 'hr@syncglob.com' : row.approvedUser.email;
  const subject = encodeURIComponent(row.leaveType);
  const body = encodeURIComponent(`Hello Sir/Mam, 
    I hope this email finds you well. I am writing to formally request a leave of absence from ${row.from} to ${row.to}. 
    The reason for my leave is ${row.reason}. 
    During my absence, I will ensure that all my current tasks are up-to-date and that any pending work is delegated appropriately. 
    I will also be available via email for any urgent matters that may arise. 
    I have discussed my absence with my colleagues and have arranged for coverage during this period to minimize any disruption to our team's workflow.
    Please let me know if you require any further information or documentation to process my leave request. 
    
    Thank you for your understanding and support.
    
    Best regards,
    ${row.user.firstName} ${row.user.lastName}`);
  const mailtoLink = `mailto:${recipient}?subject=${subject}&body=${body}`;
  window.location.href = mailtoLink;

  return <></>;
};

export { SendMail };
